/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditEntryDto } from './AuditEntryDto';
import {
    AuditEntryDtoFromJSON,
    AuditEntryDtoFromJSONTyped,
    AuditEntryDtoToJSON,
    AuditEntryDtoToJSONTyped,
} from './AuditEntryDto';

/**
 * 
 * @export
 * @interface GetTunnelAuditHistoryResponse
 */
export interface GetTunnelAuditHistoryResponse {
    /**
     * List of audit entries
     * @type {Array<AuditEntryDto>}
     * @memberof GetTunnelAuditHistoryResponse
     */
    entries?: Array<AuditEntryDto>;
    /**
     * Total number of audit entries
     * @type {number}
     * @memberof GetTunnelAuditHistoryResponse
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the GetTunnelAuditHistoryResponse interface.
 */
export function instanceOfGetTunnelAuditHistoryResponse(value: object): value is GetTunnelAuditHistoryResponse {
    return true;
}

export function GetTunnelAuditHistoryResponseFromJSON(json: any): GetTunnelAuditHistoryResponse {
    return GetTunnelAuditHistoryResponseFromJSONTyped(json, false);
}

export function GetTunnelAuditHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTunnelAuditHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': json['entries'] == null ? undefined : ((json['entries'] as Array<any>).map(AuditEntryDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
    };
}

export function GetTunnelAuditHistoryResponseToJSON(json: any): GetTunnelAuditHistoryResponse {
    return GetTunnelAuditHistoryResponseToJSONTyped(json, false);
}

export function GetTunnelAuditHistoryResponseToJSONTyped(value?: GetTunnelAuditHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entries': value['entries'] == null ? undefined : ((value['entries'] as Array<any>).map(AuditEntryDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

